export enum ResponseType {
	text = 'text',
	json = 'json',
	arrayBuffer = 'arraybuffer',
	blob = 'blob',
}
